var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M0 0h80v80H0V0Zm53.333 32c-5.89 0-10.666 4.776-10.666 10.667 0 5.89 4.775 10.666 10.666 10.666h5.334a5.333 5.333 0 1 1 0 10.667h-5.334A5.333 5.333 0 0 1 48 58.667h-5.333c0 5.89 4.775 10.666 10.666 10.666h5.334c5.89 0 10.666-4.775 10.666-10.666S64.558 48 58.667 48h-5.334a5.333 5.333 0 0 1 0-10.667h6.223A4.444 4.444 0 0 1 64 41.778v.889h5.333v-.89c0-5.4-4.377-9.777-9.777-9.777h-6.223ZM16 32h26.667v5.333H32v32h-5.333v-32H16V32Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.3134d5546ffa57662a7deb1b4bd1ea12.svg";
export { ForwardRef as ReactComponent };